// @flow
export { default as TableProducts } from './TableProducts';
